import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class CanalVentaService {

    async getCanalVentaSelect() {
        const canalventa = await fetchWrapper.get(`${ruta}/canal-venta/select`);
        return canalventa;
    }

    async getCanalesVenta() {
        // Asumiendo que esta es la ruta principal del listado
        const canalventa = await fetchWrapper.get(`${ruta}/canal-venta`);
        return canalventa;
    }

    async crearCanalVenta(datos) {
        return await fetchWrapper.post(`${ruta}/canal-venta`, datos);
    }

    async updateCanalVenta(id, datos) {
        return await fetchWrapper.put(`${ruta}/canal-venta/${id}`, datos);
    }

    async deleteCanalVenta(id) {
        return await fetchWrapper.delete(`${ruta}/canal-venta/${id}`);
    }
}